import { render, staticRenderFns } from "./ErrorsTable.vue?vue&type=template&id=189e37b7"
import script from "./ErrorsTable.vue?vue&type=script&lang=ts"
export * from "./ErrorsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports